// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"292":"233add82","924":"dab231ab"}[chunkId] + ".css";
};